export default "__VITE_ASSET__c8bbe751__"